import React from 'react';
import { useSelector } from 'react-redux';
import { shouldShowModeratorSettings } from '../../functions.web';
import FollowMeButton from './FollowMeButton';
const FollowMeContainerButton = (props) => {
    const showModeratorSettings = useSelector((state) => shouldShowModeratorSettings(state));
    const { conference } = useSelector((state) => state['features/base/conference']);
    // Only show the follow-me button if moderator settings should be shown and there's an active conference
    const shouldShowFollowMeButton = Boolean(conference && showModeratorSettings);
    return shouldShowFollowMeButton
        ? React.createElement(FollowMeButton, { ...props })
        : null;
};
export default FollowMeContainerButton;
